import * as React from 'react';
import moment from 'moment';

import { IPackageListingState, ISpecialFeatureMapValue } from '../../classes/package-listing';
import { connect } from 'react-redux';

import PackageListingContainerView from 'package-listing-container.view';
import { IPackageListingAppState } from '../../redux-state';

interface IOwnProps {

}

interface StateToProps {
    specialFeatureMap: Map<string, ISpecialFeatureMapValue>;
}

export type PackageListingContainerProps = IOwnProps & StateToProps;

export class SpecialFeatureList extends React.Component<PackageListingContainerProps, any> {

    render() {
        const { specialFeatureMap } = this.props;

        if (!specialFeatureMap || specialFeatureMap.size < 1) return null;

        return (
            <ul>
                {
                    [...specialFeatureMap.keys()].map(key => {
                        const mapValue = specialFeatureMap.get(key);

                        return (
                            <li key={key}>
                                <p>{`${mapValue.symbol} ${mapValue.message}`}</p>
                            </li>
                        );
                    })
                }

            </ul>
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, _ownProps: IOwnProps): StateToProps {
    return {
        specialFeatureMap: state.packageListing.specialFeatureMap,
    }
}

export default connect<StateToProps>(mapStateToProps)(SpecialFeatureList);